module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wine@3x_81c13c.jpg";